import {
  Button,
  type ButtonProps,
  type SxProps,
  type Theme,
  Typography,
} from "@mui/material";
import type { FC } from "react";

type Props = Omit<ButtonProps, "variant">;

const buttonStyles: SxProps<Theme> = {
  padding: "0 !important",
  backgroundColor: "inherit",
  textTransform: "none",
  "&:hover": {
    backgroundColor: "inherit",
  },
  minWidth: 0,
};

const typographyStyles: SxProps<Theme> = {
  backgroundClip: "text",
  WebkitTextFillColor: "transparent",
  display: "flex",
};

export const BlTextButton: FC<Props> = (props) => {
  const { color = "primary", ...rest } = props;
  const paletteColor = color === "inherit" ? "primary" : color;

  return (
    <Button color={color} variant="text" {...rest} sx={buttonStyles}>
      <Typography
        color={paletteColor}
        fontWeight={600}
        sx={{
          backgroundColor: (theme) => theme.palette[paletteColor].main,
          ...typographyStyles,
        }}
      >
        {props.children}
      </Typography>
    </Button>
  );
};
